import { brandsConstants } from '@constants/brands';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { brandsService } from '@services';

const get = (page = 0, pageSize = DEFAULT_PAGE_SIZE) => {
    return dispatch => {
        dispatch(request());
        brandsService.get(page, pageSize).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
};

const getAll = () => {
    return dispatch => {
        dispatch(request());
        brandsService.getAll().then(
            data => dispatch(successAll(data)),
            () => dispatch(failure()),
        );
    };
};

const getDefault = () => {
    return dispatch => {
        brandsService.getDefault().then(
            data => dispatch(successDefault(data)),
            () => dispatch(failureDefault()),
        );
    };
};

function request() {
    return { type: brandsConstants.BRANDS_REQUEST };
}

function success(data) {
    return { type: brandsConstants.BRANDS_SUCCESS, data };
}

function successAll(data) {
    return { type: brandsConstants.BRANDS_ALL_SUCCESS, data };
}

function successDefault(data) {
    return { type: brandsConstants.BRAND_DEFAULT_SUCCESS, data };
}

function failureDefault() {
    return { type: brandsConstants.BRAND_DEFAULT_FAILURE };
}

function failure() {
    return { type: brandsConstants.BRANDS_FAILURE };
}

export const brandsActions = {
    get,
    getAll,
    getDefault,
};
